import * as React from "react";
import {Edit} from 'react-admin';
import Box from "@mui/material/Box";

export const JobEdit = () => (
    <Edit title={'Munka szerkesztése'}>
        <Box/>
    </Edit>
);
